import { GAMIFICATION_ROUTES } from "./gamificationRoutes";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import FilterActivity from "./FilterActivity";
import ActivityCard from "./ActivityCard";
import { useUserCoinsHistory } from "../../hooks/useUserCoinsHistory";
import {
  DEFAULT_GAMIFICATION_ACTIVITY_FILTER,
  useGamificationFilterList,
} from "../../hooks/useGamificationFilterList";
import {
  buildGamificationBackTarget,
  buildGamificationFlowState,
  getStoredGamificationFlowState,
  persistGamificationFlowState,
} from "./gamificationFlowState";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "./Coinhistory.css";
import "../../questionBank/QuestionBankList.css";
import HeaderProfileSection from "../HeaderProfileSection";
import MyWalletSidebar from "../MyWalletSidebar";
import { SUBSCRIPTION_ROUTES } from "../subscription/subscriptionRoutes";

const DEFAULT_FILTER_OPTIONS = [DEFAULT_GAMIFICATION_ACTIVITY_FILTER];

const CoinHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const flowState = useMemo(
    () => buildGamificationFlowState(location.state, getStoredGamificationFlowState()),
    [location.state]
  );
  const isSubscriptionEntry = location.pathname === SUBSCRIPTION_ROUTES.coinHistory;
  const backTarget = useMemo(() => {
    const target = flowState?.gamificationBackTarget;
    if (isSubscriptionEntry) {
      return target?.pathname === SUBSCRIPTION_ROUTES.coinStore
        ? target
        : buildGamificationBackTarget(SUBSCRIPTION_ROUTES.coinStore, flowState);
    }
    return target?.pathname ? target : buildGamificationBackTarget(GAMIFICATION_ROUTES.coinStore, flowState);
  }, [flowState, isSubscriptionEntry]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedActivity, setSelectedActivity] = useState(DEFAULT_GAMIFICATION_ACTIVITY_FILTER);

  useEffect(() => {
    persistGamificationFlowState({
      ...flowState,
      gamificationBackTarget: backTarget,
    });
  }, [flowState, backTarget]);

  const {
    data: filterData,
    isLoading: isFiltersLoading,
    isFetching: isFiltersFetching,
  } = useGamificationFilterList({ enabled: true });
  const filterOptions = useMemo(
    () => filterData?.filters || DEFAULT_FILTER_OPTIONS,
    [filterData?.filters]
  );

  useEffect(() => {
    const hasSelectedFilter = filterOptions.some((item) => item.key === selectedActivity.key);

    if (!hasSelectedFilter) {
      setSelectedActivity(DEFAULT_GAMIFICATION_ACTIVITY_FILTER);
    }
  }, [filterOptions, selectedActivity.key]);

  const { data, isLoading, isFetching, isError, error } = useUserCoinsHistory(
    {
      page: currentPage,
      ...(selectedActivity?.key ? { activity_key: selectedActivity.key } : {}),
    },
    { enabled: true }
  );

  const handleSelectActivity = (activity) => {
    setCurrentPage(1);
    setSelectedActivity(activity || DEFAULT_GAMIFICATION_ACTIVITY_FILTER);
  };

  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load coin history."
    : "";

  return (
    <>
      <style>{`
          .homeDashboard-wrapper .page-content {
            padding-right: 0;
          }
      .homeDashboard-wrapper .main-content {
          height: 100vh;
          overflow: hidden;
          box-sizing: border-box;
          padding-bottom: 35px;
          min-height:0;
        }
      `}</style>
      <HomeDashboardLayout showHeader={false}>
        <div className="qbl-page qbankList-page page-padding start-gamification ">
          <div className="start-quiz qbl-main  instruction-main">
            <div className="hideProfile-page ">
              <div className="categories-page-header mb-0">
                <div>
                  <button
                    type="button"
                    className="categories-back-button"
                    onClick={() =>
                      navigate(backTarget.pathname, {
                        replace: true,
                        state: backTarget.state,
                      })
                    }
                    aria-label="Go back"
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </div>
                <div>
                  <h4 className="d-flex categories-page-title"> </h4>
                </div>
                <div>
                  <HeaderProfileSection />
                </div>
              </div>
            </div>

            <section className="coinWalletPanel">
              <div className="rapid-fire-header">
                <h1 className="qb-title"> Coin History</h1>
              </div>

              <p className="game-description">Complete, Learn & improve Daily</p>

              <div className="coinWalletPanel__container coin-wrap">
                <div className="coinWalletPanel__coinHolder">
                  <div className="coinWalletPanel__coinShape">
                    <span className="coinWalletPanel__coinMark">$</span>
                  </div>
                </div>

                <div className="coinWalletPanel__info">
                  <span className="coinWalletPanel__heading">CURRENT BALANCE</span>

                  <div className="coinWalletPanel__balance">
                    <strong className="coinWalletPanel__number">{data?.currentCoins || 0}</strong>
                    <span className="coinWalletPanel__text">Coins</span>
                  </div>
                </div>
              </div>
            </section>

            <FilterActivity
              options={filterOptions}
              selectedActivityKey={selectedActivity.key}
              onSelect={handleSelectActivity}
              isLoading={isFiltersLoading || isFiltersFetching}
            />

            {loadError ? (
              <p className="choose-state__status choose-state__status--error">{loadError}</p>
            ) : (
              <ActivityCard
                items={data?.history || []}
                selectedFilterLabel={selectedActivity.name}
                pagination={data?.pagination || {}}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                isLoading={isLoading || isFetching}
              />
            )}
          </div>

          <MyWalletSidebar withTopOffset={false} />
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default CoinHistory;
